import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * Renders the answer cell for one decomposition step (tens / singles / carry).
 * - When the step is not active, shows the running partial sum (`value`).
 * - When active and `typedAnswers` is on, shows a keypad input once the cartons
 *   are placed correctly (`correct`), with wrong-answer feedback styling.
 * - When active and `typedAnswers` is off, shows the elision mark.
 */
@Component({
  selector: 'rid-egg-carton-step-answer',
  template: `
    @if (active()) {
      @if (typedAnswers()) {
        @if (correct()) {
          <div
            [ngClass]="{ 'border-red-500! ring-red-500/50!': incorrect(), 'anim-shake': shaking() }"
            class="ring-primary-400/50 flex size-full items-center justify-end gap-2 rounded-lg border-4 border-dotted border-white bg-white/30 px-2 ring-6"
          >
            {{ answer() }}
          </div>
        } @else {
          <span class="text-white">?</span>
        }
      } @else {
        <span class="text-white">...</span>
      }
    } @else {
      <span class="text-white">{{ value() }}</span>
    }
  `,
  imports: [NgClass],
  host: {
    class: 'contents',
  },
})
export class RidEggCartonStepAnswer {
  active = input.required<boolean>();
  typedAnswers = input(false);
  correct = input(false);
  incorrect = input(false);
  shaking = input(false);
  answer = input('');
  value = input(0);
}
